module.exports = __webpack_public_path__ + "img/intro-hero.cc3daea4.jpeg";